export const keyPrefix = "PAC_AGENTS_REDUCER_";

export const PAC_AGENTS_ACTIONS = {
    SET_SELECTED_VERSION_WITH_AGENTS: keyPrefix + "SET_SELECTED_VERSION_WITH_AGENTS",
    CLEAR_SELECTED_VERSION_WITH_AGENTS: keyPrefix + "CLEAR_SELECTED_VERSION_WITH_AGENTS",
    SET_SELECTED_VERSION_PRD_DATA: keyPrefix + "SET_SELECTED_VERSION_PRD_DATA",
    SET_SELECTED_VERSION_JD_DATA: keyPrefix + "SET_SELECTED_VERSION_JD_DATA",
    CLEAR_SELECTED_VERSION_PRD_DATA: keyPrefix + "CLEAR_SELECTED_VERSION_PRD_DATA",
    CLEAR_SELECTED_VERSION_JD_DATA: keyPrefix + "CLEAR_SELECTED_VERSION_JD_DATA"
}

export const setSelectedVersionWithAgents = (versionWithAgentsData) => {
    return {
        type: PAC_AGENTS_ACTIONS.SET_SELECTED_VERSION_WITH_AGENTS,
        payload: versionWithAgentsData
    }
}

export const clearSelectedVersionWithAgents = () => {
    return {
        type: PAC_AGENTS_ACTIONS.CLEAR_SELECTED_VERSION_WITH_AGENTS,
        payload: null
    }
}

export const setSelectedVersionPrdData = (prdData) => {
    return {
        type: PAC_AGENTS_ACTIONS.SET_SELECTED_VERSION_PRD_DATA,
        payload: prdData
    }
}

export const clearSelectedVersionPrdData = () => {
    return {
        type: PAC_AGENTS_ACTIONS.CLEAR_SELECTED_VERSION_PRD_DATA,
        payload: null
    }
}

export const setSelectedVersionJdData = (jdData) => {
    return {
        type: PAC_AGENTS_ACTIONS.SET_SELECTED_VERSION_JD_DATA,
        payload: jdData
    }
}

export const clearSelectedVersionJdData = () => {
    return {
        type: PAC_AGENTS_ACTIONS.CLEAR_SELECTED_VERSION_JD_DATA,
        payload: null
    }
}